import { Crown, ShieldCheck, Sparkles, Flame, Award } from "lucide-react";
import { cn } from "@/lib/utils";
import type { PremiumTier } from "@/lib/chef-utils";

const base =
  "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider";

export function PremiumBadge({ className }: { className?: string }) {
  return (
    <span className={cn(base, "bg-gold text-gold-foreground shadow-sm", className)}>
      <Crown className="h-3 w-3" /> Premium
    </span>
  );
}

/** Sprint 19.1 — Premium Silver (argento). */
export function SilverBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        base,
        "bg-gradient-to-r from-slate-300 to-slate-200 text-slate-900 ring-1 ring-slate-400/60 shadow-sm",
        className,
      )}
    >
      <Award className="h-3 w-3" /> Silver
    </span>
  );
}

/** Sprint 19.1 — Premium Gold (oro). */
export function GoldBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        base,
        "bg-gradient-to-r from-amber-400 to-yellow-500 text-black ring-1 ring-amber-700/40 shadow-md",
        className,
      )}
    >
      <Crown className="h-3 w-3" /> Gold
    </span>
  );
}

/** Helper: rende il badge corretto per il tier. Free → nulla. */
export function TierBadge({ tier, className }: { tier: PremiumTier; className?: string }) {
  if (tier === "gold") return <GoldBadge className={className} />;
  if (tier === "silver") return <SilverBadge className={className} />;
  return null;
}

export function VerifiedBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        base,
        "bg-blue-600 text-white shadow-sm dark:bg-blue-500",
        className,
      )}
    >
      <ShieldCheck className="h-3 w-3" /> Verificato
    </span>
  );
}

export function FounderBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        base,
        "bg-foreground text-background ring-1 ring-gold",
        className,
      )}
    >
      <Sparkles className="h-3 w-3 text-gold" /> Founder
    </span>
  );
}

export function SponsoredBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        base,
        "bg-red-600 text-white shadow-sm",
        className,
      )}
    >
      <Flame className="h-3 w-3" /> In evidenza
    </span>
  );
}